import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useAuth } from "../../Context/AuthContext";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import Divider from "@mui/material/Divider";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_REST_URL;
const style = {
  width: "80vw",
  maxHeight: "85vh",
  // maxWidth: 1000,
  // maxHeight: 620,
  bgcolor: "background.paper",
  border: "2px solid #000",
  // borderRadius: "20px",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  // overflowY: "scroll",
  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
};
const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};

const PartnersComponent = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(true);
  const [referrals, setReferrals] = useState([]);
  const [filteredReferrals, setFilteredReferrals] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalDataObj, setModalDataObj] = useState();
  const [professions, setProfessions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [userId, setUserId] = useState(null);
  const [userarray, setUserarray] = useState(null);
  const [, setDataFetched] = useState(false);
  const [customProfession, setCustomProfession] = useState("");
  const roleId = sessionStorage.getItem("roleId");
  const [currentUser, setCurrentUser] = useState("");

  const handleCheck = async () => {
    const res = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/users`, {
      roleId: "1,2,6,7",
    });
    const result = res.data.response;
    const username = result.map((profession) => ({
      value: profession.id,
      label: `${profession.firstname} ${profession.lastname}`,
    }));
    console.log("username", username);
    setUserarray(username);
  };

  useEffect(() => {
    handleCheck();
  }, []);

  const {
    register,
    reset,
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({ mode: "onTouched" });

  const data = {
    userId: userId,
  };

  const initialKycStatus = [
    {
      feildName: "Name As Per Pan",
      status: "Pending",
      keyWord: "nameAsPerPanStatus",
    },
    { feildName: "PAN", status: "Pending", keyWord: "panNumberStatus" },
    {
      feildName: "DOB Of Investor",
      status: "Pending",
      keyWord: "dobOfInvestorStatus",
    },
    {
      feildName: "Place Of Birth",
      status: "Pending",
      keyWord: "placeOfBirthStatus",
    },
    {
      feildName: "Postal Address 1",
      status: "Pending",
      keyWord: "postalAddress1Status",
    },
    {
      feildName: "Postal Address 2",
      status: "Pending",
      keyWord: "postalAddress2Status",
    },
    { feildName: "City", status: "Pending", keyWord: "kycCityStatus" },
    { feildName: "State", status: "Pending", keyWord: "kycStateStatus" },
    { feildName: "Pin Code", status: "Pending", keyWord: "pincodeStatus" },
    {
      feildName: "Nominee Name",
      status: "Pending",
      keyWord: "nomineeNameStatus",
    },
    {
      feildName: "Nominee DOB",
      status: "Pending",
      keyWord: "nomineeDobStatus",
    },
    {
      feildName: "Nominee Relation With Investor",
      status: "Pending",
      keyWord: "nomineeRelationWithInvestorStatus",
    },
    { feildName: "Occupation", status: "Pending", keyWord: "occupationStatus" },
    {
      feildName: "Investor's Income Range",
      status: "Pending",
      keyWord: "investorsIncomeRangeStatus",
    },
    {
      feildName: "Source Of Income",
      status: "Pending",
      keyWord: "sourceOfIncomeStatus",
    },
    { feildName: "PAN Image", status: "Pending", keyWord: "panImgStatus" },
    {
      feildName: "Cancelled Cheque Image",
      status: "Pending",
      keyWord: "cancelledCheckImgStatus",
    },
    {
      feildName: "CKYC Number ",
      status: "Pending",
      keyWord: "ckycNumberStatus",
    },
  ];
  const [kycStatusObj, setKycStatusObj] = useState({
    status: false,
    data: initialKycStatus,
  });

  useEffect(() => {
    console.log(modalDataObj, "modalDataObj");
  }, [modalDataObj]);
  const fetchReferrals = async () => {
    setLoading(true);
    const headers = {
      "x-access-token": token,
    };
    try {
      const apiResponse = await axios.post(
        `${apiUrl}/CCE/api/v1/userEngine/getPartners`,
        {},
        {
          headers,
        }
      );
      console.log("partner");
      console.log("partner", apiResponse);
      console.log("partner");

      if (apiResponse?.data?.response) {
        setReferrals(apiResponse.data.response);
        setFilteredReferrals(apiResponse.data.response); // Initialize with all data
      }
    } catch (error) {
      console.error("Error fetching partners:", error.message);
    }
    setLoading(false);
  };
  const fetchDropdownData = async () => {
    try {
      const professionResponse = await axios.get(
        `${apiUrl}/CCE/api/v1/commonEngine/professions`
      );
      const professionData = professionResponse.data.response.map(
        (profession) => ({
          id: profession.id,
          profession_name: profession.profession_name,
        })
      );
      setProfessions(professionData);
      console.log("professionData", professionData);
      const stateResponse = await axios.get(
        `${apiUrl}/CCE/api/v1/commonEngine/state`
      );
      const stateData = stateResponse.data.response.map((state) => ({
        id: state.id,
        statename: state.statename
          .toLowerCase()
          .replace(/\b\w/g, (c) => c.toUpperCase()),
      }));
      setStates(stateData);
      console.log("seelve1", stateData);
      const cityResponse = await axios.get(
        `${apiUrl}/CCE/api/v1/commonEngine/cities`
      );
      const cityData = cityResponse.data.response.map((city) => ({
        id: city.id,
        cityname: city.cityname,
      }));
      setCities(cityData);
      console.log("seelve1", cityData);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);
  const findIdByName = (array, name, key) => {
    if (!name) return "";
    const item = array.find(
      (item) => item[key].toLowerCase() === name.toLowerCase()
    );
    console.log(item, "UOHo");
    return item ? item.id : "";
  };

  const formatDateForInput = (dateString) => {
    if (dateString) {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    } else {
      return null;
    }
  };

  // In handleOpen function
  const handleOpen = (id) => {
    if (referrals.length > 0) {
      setUserId(id);
      const _obj = referrals.find((obj) => obj.id === id);
      console.log(id, referrals, _obj, "sdgfsdfsdg");
      const {
        firstname,
        middleName,
        lastname,
        dob,
        phone,
        pointOfContact,
        email,
        agreement,
        profession,
        state,
        city,
        gender,
        kycStatus,
      } = _obj;
      initialKycStatus.map((dta, idx) => {
        dta.status = _obj?.[dta.keyWord];
      });
      // console.log(initialKycStatus, "idx");
      setKycStatusObj({ status: true, data: initialKycStatus });
      setValue("dob", formatDateForInput(dob));
      setValue("kycStatus", kycStatus);
      setValue("pointOfContact", pointOfContact);
      setValue("middleName", middleName);
      setValue("firstname", firstname);
      setValue("lastname", lastname);
      // setValue("gender", gender);
      setValue("phone", phone);
      setValue("email", email);
      // setValue("agreement", agreement);
      if (profession === null) {
        setValue("profession", "");
        setCustomProfession("");
      } else {
        const professionId = professions.find(
          (p) => p.profession_name === profession
        )?.id;
        if (professionId) {
          setValue("profession", professionId);
          setCustomProfession("");
        } else {
          setValue("profession", 6); // Assuming 6 is the ID for "Other"
          setCustomProfession(profession);
        }
      }

      // Handle state and city
      setValue(
        "state",
        state === null ? "" : findIdByName(states, state, "statename")
      );
      setValue(
        "city",
        city === null ? "" : findIdByName(cities, city, "cityname")
      );
      console.log(
        findIdByName(gender_array, gender, "gender_name"),
        "findIdByName"
      );
      setValue(
        "gender",
        gender === null ? "" : findIdByName(gender_array, gender, "gender_name")
      );
      setValue(
        "agreement",
        agreement === null
          ? ""
          : findIdByName(agreement_array, agreement, "agreement_name")
      );
      const formValues = getValues();
      setModalDataObj(formValues);
      setOpen(true);
      setCurrentUser(`${firstname} ${lastname}`);
    }
  };
  // console.log("rf", apiData);
  console.log("rf", searchQuery);
  console.log("rf", referrals);

  useEffect(() => {
    fetchReferrals();
  }, []);
  // useEffect(() => {
  //   if (searchQuery === "") {
  //     setFilteredReferrals(referrals); // Show all if no search query
  //   } else {
  //     const query = searchQuery.toLowerCase();
  //     const filtered = referrals.filter((referral) => {
  //       const fullName =
  //         `${referral.firstname} ${referral.lastname}`.toLowerCase();
  //       const email = (referral.email || "").toLowerCase();
  //       return fullName.includes(query) || email.includes(query);
  //     });
  //     setFilteredReferrals(filtered);
  //   }
  // }, [searchQuery, referrals]);

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = referrals.filter((referral) => {
      const fullName =
        `${referral.firstname} ${referral.lastname}`.toLowerCase();
      const email = (referral.email || "").toLowerCase();
      return fullName.includes(query) || email.includes(query);
    });

    setFilteredReferrals(filtered);
  };
  //--------------------------------------
  const gender_array = [
    { id: 1, gender_name: "Male" },
    { id: 2, gender_name: "Female" },
  ];
  const agreement_array = [
    { id: 1, agreement_name: "Electronically Signed" },
    { id: 2, agreement_name: "Hard Copy Signed" },
    { id: 3, agreement_name: "Pending" },
  ];
  const formatPhoneNumber = (phoneNumber) => {
    const phoneNumberString = phoneNumber?.toString() || ""; // Add null check
    if (phoneNumberString.length === 10) {
      return `${phoneNumberString.substring(
        0,
        5
      )} ${phoneNumberString.substring(5)}`;
    } else {
      return phoneNumberString;
    }
  };

  //--------------------------------------
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };

  const getKycStatusBox = (kycStatus) => {
    const styles = {
      Completed: {
        border: "2px solid green",
        color: "green",
      },
      Pending: {
        border: "2px solid red",
        color: "red",
      },
      default: {
        border: "2px solid gray",
        color: "black",
      },
    };

    const currentStyle = styles[kycStatus] || styles.default;

    return (
      <Box
        component="span"
        sx={{
          ...currentStyle,
          width: "150px",
          borderRadius: "30px",
          px: 1,
          py: 0.5,
          fontWeight: "bold",
          fontSize: "15px",
          marginLeft: 1,
        }}
      >
        {kycStatus}
      </Box>
    );
  };
  //--------------------------------------
  const onSubmit = async (data) => {
    console.log("update button call", data);

    const agreementMap = {
      1: "Electronically Signed",
      2: "Hard Copy Signed",
      3: "Pending",
    };
    const genderMap = {
      1: "Male",
      2: "Female",
    };

    const payload = {
      userId: userId,
      firstname: data.firstname,
      lastname: data.lastname,
      phone: parseInt(data.phone, 10),
      email: data.email,
      agreement: agreementMap[data.agreement],
      cityId: parseInt(data.city, 10),
      professionId: parseInt(data.profession, 10),
      stateId: parseInt(data.state, 10),
      dob: data.dob,
      middleName: data.middleName,
      gender: genderMap[data?.gender],
      pointOfContact: data.pointOfContact,
    };
    console.log(payload, "findIdByName");

    if (payload.professionId === 6) {
      payload.custom_profession = customProfession;
    }

    try {
      const response = await axios.post(
        `${apiUrl}/CCE/api/v1/userEngine/updatePartner`,
        payload
      );

      if (response?.data?.statusMessage === "Success") {
        toast.success("Partner updated successfully");
        fetchReferrals(); // Refresh the data
      } else {
        toast.error("Update failed");
      }
      console.log("clientRes", response);
    } catch (error) {
      console.error("Error updating partner:", error);
      toast.error("Update failed");
    }

    reset();
    handleClose();
  };
  const columns = [
    {
      field: "referralName",
      headerName: "Partner Name",
      valueGetter: (params) =>
        `${params.row.firstname || ""} ${params.row.lastname || ""}`.trim(),
      renderCell:
        roleId === "1" || roleId === "6"
          ? (params) => (
              <div
                title={`${params.row.firstname} ${params.row.lastname}`}
                onClick={() => handleOpen(params.row.id)}
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "160px",
                }}
              >
                {params.row.firstname} {params.row.lastname}
              </div>
            )
          : (params) => (
              <div title={`${params.row.firstname} ${params.row.lastname}`}>
                {params.row.firstname} {params.row.lastname}
              </div>
            ),
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 200,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      // type: "number",
      valueFormatter: (params) => formatPhoneNumber(params.value),
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "agreement",
      headerName: "Agreement",
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "created_date",
      headerName: "Added On",
      valueGetter: (params) => formatDateString(params.value),
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },

    {
      field: "pointOfContactName",
      headerName: "Point of Contact",
      // valueFormatter: (params) => formatDateString(params.value),
      width: 180,
      headerClassName: "boldHeader",
      valueGetter: (params) => params.value || "-",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },

    {
      field: "points",
      headerName: "Points Earned",
      // valueFormatter: (params) => formatDateString(params.value),
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "payouts",
      headerName: "Payout",
      // valueFormatter: (params) => formatDateString(params.value),
      width: 180,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
  ];
  console.log(watch("profession"), "helo11");
  const handleDownloadCSV = () => {
    const csvData = filteredReferrals.map((row) => ({
      "Partner Name": `${row.firstname} ${row.lastname}`,
      "Email Address": row.email || "-",
      "Phone Number": row.phone ? formatPhoneNumber(row.phone) : "-",
      Agreement: row.agreement || "-",
      "Added On": formatDateString(row.created_date),
      "Point of Contact": row.pointOfContactName || "-",
      "Points Earned": row.points || "-",
      Payout: row.payouts || "-",
    }));

    return csvData;
  };

  return (
    <Box sx={styles.main_container}>
      <Paper sx={styles.dashboard_paper}>
        <h3>Partners</h3>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "50%",
            marginLeft: "auto",
          }}
        >
          <Button
            sx={styles.btnback}
            variant="contained"
            onClick={() => navigate("/employeedashboard")}
          >
            Back
          </Button>
        </Box>
      </Paper>
      <Box
        sx={{
          width: "100%",
          height: "92vh",
          background: "#f2f2f2",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            margin: "10px 20px 20px 20px",
            height: "590px",
            borderRadius: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 15px",
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              {/* ----------------------------Filter--------------------------------------- */}
              <Box
                sx={{
                  textAlign: "left",
                  position: "relative",
                  margin: "5px 0px",
                }}
              >
                <input
                  style={{
                    width: "200px",
                    height: "30px",
                    fontSize: "11px",
                    borderRadius: "8px",
                    paddingLeft: "35px",
                  }}
                  type="text"
                  placeholder="Search by Partner Name / Email"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <SearchIcon
                  sx={{
                    position: "absolute",
                    left: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "grey",
                  }}
                />
                {(roleId === "1" || roleId === "6" || roleId === "7") && (
                  <CSVLink
                    data={handleDownloadCSV()}
                    filename="partners.csv"
                    style={{ textDecoration: "none" }}
                  >
                    <Button sx={styles.btn} variant="contained">
                      Download CSV
                    </Button>
                  </CSVLink>
                )}
              </Box>
              {/* ---------------------------------------------------------------------- */}
            </Box>
          </Box>

          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div style={{ height: 535, width: "100%" }}>
              <DataGrid
                rows={filteredReferrals}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                // sx={sxStyles.boldHeader}
                sx={{
                  ...sxStyles.boldHeader,
                  fontSize: "13px",
                  "& .MuiDataGrid-columnHeaders": {
                    textAlign: "center",
                    fontWeight: "bold",
                  },
                  "& .centerAlign": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  },
                }}
              />
            </div>
          )}
        </Paper>
        <Box>
          <ToastContainer
            position="bottom-right"
            autoClose={7000}
            newestOnTop={true}
            closeOnClick
            pauseOnHover
            toastStyle={{ textAlign: "left" }}
            theme="colored"
          />
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // maxHeight: "80vh",
              // top: "10vh",
            }}
          >
            <Box sx={style}>
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "-20px",
                  marginBottom: "10px",
                }}
              ></Box> */}
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ marginBottom: "1rem", textAlign: "center" }}
              >
                <>Update Partner </>
                <Typography variant="span" sx={{ ml: 0.5, fontWeight: "bold" }}>
                  {currentUser}
                </Typography>
                {/* <CloseIcon
                  sx={{ color: "#b3b3b3", cursor: "pointer", float: "right" }}
                  onClick={handleClose}
                /> */}
              </Typography>
              <Typography variant="h6" sx={{ ml: 1, mb: 1 }}>
                KYC Status
                <Box
                  component="span"
                  sx={{
                    border:
                      watch("kycStatus") === "Completed"
                        ? "2px solid green"
                        : watch("kycStatus") === "Pending"
                        ? "2px solid red"
                        : watch("kycStatus") === "Incomplete"
                        ? "2px solid orange"
                        : "2px solid gray",
                    width: "150px",
                    borderRadius: "30px",
                    color:
                      watch("kycStatus") === "Completed"
                        ? "green"
                        : watch("kycStatus") === "Pending"
                        ? "red"
                        : watch("kycStatus") === "Incomplete"
                        ? "orange"
                        : "black",
                    px: 1,
                    py: 0.5,
                    fontWeight: "bold",
                    fontSize: "15px",
                    marginLeft: 1,
                  }}
                >
                  {watch("kycStatus")}
                </Box>
              </Typography>
              <Box>
                <Paper
                  elevation={10}
                  sx={{
                    backgroundColor: "#213B68",
                    color: "#ffffff",
                    py: 1.5,
                    px: 2,
                    borderRadius: "5px",
                  }}
                >
                  Partner Details
                </Paper>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={2} my={1}>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="medium"
                        sx={styles.textfield}
                        id="outlined-basic"
                        label="First name"
                        variant="outlined"
                        {...register("firstname", {
                          // required: "First Name is required",
                          pattern: {
                            value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                            message: "Only alphabets are allowed",
                          },
                        })}
                      />
                      {errors.firstname && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            textAlign: "left",
                            marginLeft: "10px",
                          }}
                        >
                          {errors.firstname.message}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="medium"
                        sx={styles.textfield}
                        id="outlined-basic"
                        label="Middle name"
                        variant="outlined"
                        {...register("middleName", {
                          // required: "Last Name is required",
                          pattern: {
                            value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                            message: "Only alphabets are allowed",
                          },
                        })}
                      />
                      {errors.middleName && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            textAlign: "left",
                            marginLeft: "10px",
                          }}
                        >
                          {errors.middleName.message}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="medium"
                        sx={styles.textfield}
                        id="outlined-basic"
                        label="Last name"
                        variant="outlined"
                        {...register("lastname", {
                          // required: "Last Name is required",
                          pattern: {
                            value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                            message: "Only alphabets are allowed",
                          },
                        })}
                      />
                      {errors.lastname && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            textAlign: "left",
                            marginLeft: "10px",
                          }}
                        >
                          {errors.lastname.message}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="medium"
                        sx={styles.textfield}
                        id="outlined-basic"
                        label="Email address"
                        variant="outlined"
                        {...register("email", {
                          pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Invalid Email Address",
                          },
                          // validate: value => !!value || !!watch('phone') || "Either Email or Phone is required",
                        })}
                      />
                      {errors.email && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            textAlign: "left",
                            marginLeft: "10px",
                          }}
                        >
                          {errors.email.message}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        size="medium"
                        sx={styles.textfield}
                        id="outlined-basic"
                        label="Phone number"
                        variant="outlined"
                        inputProps={{ maxLength: 10 }}
                        {...register("phone", {
                          pattern: {
                            value: /^\d{10}$/,
                            message: "Invalid Phone Number (10 digits)",
                          },
                          validate: (value) => !!value || !!watch("email"),
                          onChange: (e) =>
                            (e.target.value = e.target.value.replace(
                              /\D/g,
                              ""
                            )),
                        })}
                      />
                      {errors.phone && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            textAlign: "left",
                            marginLeft: "10px",
                          }}
                        >
                          {errors.phone.message}
                        </div>
                      )}
                    </Grid>{" "}
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        fullWidth
                        size="medium"
                        sx={styles.textfield}
                      >
                        <InputLabel id="agreement-label">
                          Point Of Contact
                        </InputLabel>
                        <Controller
                          name="pointOfContact"
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            // <Select
                            //   {...field}
                            //   sx={{ border: "1 px solid green" }}
                            //   labelId="profession-label"
                            //   id="profession"
                            //   value={username}
                            //   onChange={handlepointofcontactChange}
                            //   options={userarray}
                            //   isSearchable
                            //   placeholder="Point of Contact"
                            // />
                            <Select
                              {...field}
                              labelId="POC-label"
                              id="pointOfContact"
                              label="Point Of Contact"
                              endAdornment={
                                field.value && (
                                  <InputAdornment position="end">
                                    <Tooltip title="Clear">
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          field.onChange(null);
                                        }}
                                        sx={{ marginRight: 2 }}
                                      >
                                        <CloseIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </InputAdornment>
                                )
                              }
                            >
                              {userarray.map((poc) => (
                                <MenuItem key={poc.value} value={poc.value}>
                                  {poc.label}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        fullWidth
                        size="medium"
                        sx={styles.textfield}
                      >
                        <InputLabel id="agreement-label">Agreement</InputLabel>
                        <Controller
                          name="agreement"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="agreement-label"
                              id="agreement"
                              label="Agreement"
                            >
                              {agreement_array.map((agreement) => (
                                <MenuItem
                                  key={agreement.id}
                                  value={agreement.id}
                                >
                                  {agreement.agreement_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Date Of Birth"
                        size="medium"
                        type="date"
                        sx={styles.textfield}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                        // Add these lines to ensure the value is controlled
                        value={watch("dob") || ""}
                        onChange={(e) => setValue("dob", e.target.value)}
                      />
                      {errors.dob && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            textAlign: "left",
                            marginLeft: "10px",
                          }}
                        >
                          {errors.dob.message}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        fullWidth
                        size="medium"
                        sx={styles.textfield}
                      >
                        <InputLabel id="agreement-label">Gender</InputLabel>
                        <Controller
                          name="gender"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="gender"
                              id="gender"
                              label="Gender"
                            >
                              {gender_array.map((gender) => (
                                <MenuItem key={gender.id} value={gender.id}>
                                  {gender.gender_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        fullWidth
                        size="medium"
                        sx={styles.textfield}
                      >
                        <InputLabel id="profession-label">
                          Select Profession
                        </InputLabel>
                        <Controller
                          name="profession"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="profession-label"
                              id="profession"
                              label="Select Profession"
                              onChange={(e) => {
                                field.onChange(e);
                                if (e.target.value !== 6) {
                                  // Assuming 6 is the ID for "Other"
                                  setCustomProfession("");
                                }
                              }}
                            >
                              {professions.map((profession) => (
                                <MenuItem
                                  key={profession.id}
                                  value={profession.id}
                                >
                                  {profession.profession_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </Grid>
                    {watch("profession") === 6 && (
                      <Grid item xs={12} sm={4}>
                        <TextField
                          size="medium"
                          label="Other Profession"
                          variant="outlined"
                          fullWidth
                          // margin="normal"
                          required
                          value={customProfession}
                          onChange={(e) => setCustomProfession(e.target.value)}
                          sx={styles.textfield}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        fullWidth
                        size="medium"
                        sx={styles.textfield}
                      >
                        <InputLabel id="state-label">Select State</InputLabel>
                        <Controller
                          name="state"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="state-label"
                              id="state"
                              label="Select State"
                            >
                              {/* <MenuItem value="">Select a state</MenuItem> */}
                              {states.map((state) => (
                                <MenuItem key={state.id} value={state.id}>
                                  {state.statename}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl
                        fullWidth
                        size="medium"
                        sx={styles.textfield}
                      >
                        <InputLabel id="city-label">Select City</InputLabel>
                        <Controller
                          name="city"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <Select
                              {...field}
                              labelId="city-label"
                              id="city"
                              label="Select City"
                            >
                              {/* <MenuItem value="">Select a city</MenuItem> */}
                              {cities.map((city) => (
                                <MenuItem key={city.id} value={city.id}>
                                  {city.cityname}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Paper
                    elevation={10}
                    sx={{
                      backgroundColor: "#213B68",
                      color: "#ffffff",
                      py: 1.5,
                      px: 2,
                      borderRadius: "5px",
                    }}
                  >
                    KYC Details
                  </Paper>
                  <Box sx={{ width: "100%", position: "relative" }}>
                    <Grid container spacing={2} my={1}>
                      {kycStatusObj?.status ? (
                        <>
                          {kycStatusObj.data.map((dta, idx) => (
                            <Grid key={idx} item xs={12} sm={4}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  py: 1,
                                  marginRight: 2,
                                  marginLeft: 2,
                                }}
                              >
                                <Box component="span">{dta.feildName}</Box>
                                <Box component="span">
                                  {getKycStatusBox(dta.status)}
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        </>
                      ) : (
                        <CircularProgress />
                      )}
                    </Grid>

                    {/* Standalone dividers */}
                    <Divider
                      orientation="vertical"
                      sx={{
                        position: "absolute",
                        left: "33.33%",
                        top: 0,
                        bottom: 0,
                        height: "100%",
                      }}
                    />
                    <Divider
                      orientation="vertical"
                      sx={{
                        position: "absolute",
                        left: "66.66%",
                        top: 0,
                        bottom: 0,
                        height: "100%",
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "2rem",
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={handleClose}
                      sx={{
                        color: "Black",
                        marginRight: "10px",
                        textTransform: "none",
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      sx={{
                        padding: "5px 15px",
                        background: "#002C51",
                        color: "#fff",
                        marginLeft: "10px",
                        textTransform: "none",
                        "&:hover": { background: "#002C51" },
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </form>
              </Box>
            </Box>
          </Modal>
        </Box>
      </Box>
    </Box>
  );
};

export default PartnersComponent;

const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "6px 20px",
  },
  btn: {
    width: "140px",
    fontSize: "11px",
    margin: "10px 11px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
  },
  btnback: {
    width: "80px",
    fontSize: "11px",
    // marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
};
